import { useEffect, useRef } from 'react'
import { Background, BackgroundVariant } from 'reactflow'

import { createNadDebug } from '../../utils/debugLog'

export const CANVAS_GRID_SIZE = 24
export const CANVAS_DOT_COLOR = 'var(--border-subtle)'
export const CANVAS_DOT_SIZE = 1.4

type CanvasBackgroundProps = {
  context: 'workspace' | 'published'
  projectId?: string
  canvasId?: string
}

const canvasBackgroundLog = createNadDebug('dw:canvas-background:theme')

/** Shared visual treatment for editable and published ReactFlow canvases. */
export function CanvasBackground({ context, projectId, canvasId }: CanvasBackgroundProps) {
  const loggedThemeRef = useRef(false)

  useEffect(() => {
    if (loggedThemeRef.current) return
    loggedThemeRef.current = true
    canvasBackgroundLog({
      event: 'canvas-background:theme-applied',
      trace_id: `canvas-background:${context}:${projectId ?? 'unknown'}:${canvasId ?? 'unknown'}`,
      context,
      project_id: projectId,
      canvas_id: canvasId,
      base_token: '--background',
      dot_token: '--border-subtle',
      pattern: 'dots',
      gap_px: CANVAS_GRID_SIZE,
      dot_size_px: CANVAS_DOT_SIZE,
      gradient_enabled: false,
    })
  }, [canvasId, context, projectId])

  return (
    <Background
      className="dreamwrite-canvas-dot-grid"
      variant={BackgroundVariant.Dots}
      gap={CANVAS_GRID_SIZE}
      size={CANVAS_DOT_SIZE}
      color={CANVAS_DOT_COLOR}
    />
  )
}
